import React from 'react';
import cn from 'classnames';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';

import { Label } from '@dealroadshow/uikit-badge/Label';

import styles from './styles.module.scss';

interface IProps {
  userPlan: UserPlanType,
  className?: string,
  fontSize?: number,
}

const UserPlanTag = ({ userPlan, className, fontSize = 10 }: IProps) => {
  const tagClasses = cn(
    styles.userPlanTag,
    className,
    {
      [styles.userPlanStarter]: UserPlan.isStarter(userPlan),
      [styles.userPlanPremium]: UserPlan.isPremium(userPlan),
      [styles.userPlanPro]: UserPlan.isPro(userPlan),
    },
  );

  return (
    <Label fontSize={ fontSize } className={ tagClasses }>{ userPlan }</Label>
  );
};

export default UserPlanTag;
